import i18n from 'i18n';

const plansData = () => [
  {
    name: "Starter",
    features: [
      {
        id: "starter-feature-1",
        text: {
          highlight: "25",
          description: i18n.t("Card.DescriptionVariantType.UniqueProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "starter-feature-2",
        text: {
          highlight: null,
          description: i18n.t("Card.DescriptionVariantType.EmailSupport")
        },
        type: "special",
        tootip: null
      }
    ]
  },
  {
    name: "Professional",
    features: [
      {
        id: "pro-feature-1",
        text: {
          highlight: "250",
          description: i18n.t("Card.DescriptionVariantType.UniqueProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "pro-feature-2",
        text: {
          highlight: "25",
          description: i18n.t("Card.DescriptionVariantType.PremiumProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "pro-feature-3",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.Invoicing")
        },
        type: "special",
        tootip: i18n.t("Card.DescriptionVariantType.InvoicingTooltip")
      },
      {
        id: "pro-feature-4",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.ChatSupport")
        },
        type: "special",
        tootip: null
      }
    ]
  },
  {
    name: "Empire",
    features: [
      {
        id: "empire-feature-1",
        text: {
          highlight: "10,000",
          description: i18n.t("Card.DescriptionVariantType.UniqueProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "empire-feature-2",
        text: {
          highlight: "10,000",
          description: i18n.t("Card.DescriptionVariantType.PremiumProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "empire-feature-3",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.Invoicing")
        },
        type: "special",
        tootip: null
      },
      {
        id: "empire-feature-4",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.ChatSupport")
        },
        type: "special",
        tootip: null
      }
    ]
  },
  {
    name: "Unicorn",
    features: [
      {
        id: "unicorn-feature-1",
        text: {
          highlight: "10,000",
          description: i18n.t("Card.DescriptionVariantType.UniqueProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "unicorn-feature-2",
        text: {
          highlight: "10,000",
          description: i18n.t("Card.DescriptionVariantType.PremiumProducts")
        },
        type: "special",
        tootip: null
      },
      {
        id: "unicorn-feature-3",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.SupplierSourcing")
        },
        type: "special",
        tootip: null
      },
      {
        id: "unicorn-feature-4",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.ProductRequests")
        },
        type: "special",
        tootip: i18n.t("Card.DescriptionVariantType.ProductRequestsTooltip")
      },
      {
        id: "unicorn-feature-5",
        text: {
          highlight: "",
          description: i18n.t("Card.DescriptionVariantType.BulkCheckout")
        },
        type: "special",
        tootip: i18n.t("Card.DescriptionVariantType.BulkCheckoutTooltip")
      }
    ]
  }
];

export default plansData


// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/staticData/plansData.js